import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
// import Grid from '@material-ui/core/Grid'; // ✅ REMOVIDO: No se usa
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Divider from '@material-ui/core/Divider';

// Icons
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import ScheduleIcon from '@material-ui/icons/Schedule';
import NotesIcon from '@material-ui/icons/Notes';

// Components
import MainContainer from '../../components/MainContainer';
import MainHeader from '../../components/MainHeader';
import Title from '../../components/Title';
import { i18n } from '../../translate/i18n';
import api from '../../services/api';
import toastError from '../../errors/toastError';

const useStyles = makeStyles((theme) => ({
  // ✅ ESTILOS PRINCIPALES
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingBottom: theme.spacing(2),
    WebkitOverflowScrolling: 'touch',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: '100%',
    },
  },
  
  // ✅ CORREGIDO: FormContainer dinámico según tema
  formContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 14,
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.mode === 'dark' ? '#334155' : '#e5e8f0'}`,
    boxShadow: theme.mode === 'dark' ? '0 1px 2px rgba(0,0,0,0.4)' : '0 1px 2px rgba(20,28,48,0.06)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.25),
      marginBottom: theme.spacing(1),
    },
  },
  
  formRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  
  formField: {
    flex: 1,
  },
  
  priorityField: {
    minWidth: 150,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      width: '100%',
    },
  },
  
  categoryField: {
    minWidth: 150,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      width: '100%',
    },
  },
  
  // ✅ CORREGIDO: TaskCard dinámico según tema
  taskCard: {
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.15)',
      transform: 'translateY(-2px)',
    },
  },
  taskSummaryCard: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
    },
  },
  taskSummaryContent: {
    flex: 1,
    minWidth: 0,
  },
  taskSummaryTitle: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'normal',
  },
  dialogContent: {
    minWidth: 520,
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
    },
  },
  detailLabel: {
    color: theme.palette.text.secondary || theme.palette.text.primary,
    fontSize: '0.75rem',
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
    textTransform: 'uppercase',
  },
  detailText: {
    color: theme.palette.text.primary,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  detailGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  taskDates: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    color: theme.palette.text.secondary || theme.palette.text.primary,
    marginTop: theme.spacing(0.75),
  },
  taskDateItem: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
  
  // ✅ CORREGIDO: CompletedTask dinámico según tema
  completedTask: {
    opacity: 0.7,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e9ecef'}`,
  },
  
  taskContent: {
    paddingBottom: theme.spacing(1),
  },
  
  // ✅ CORREGIDO: TaskTitle dinámico según tema
  taskTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  
  taskMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      gap: theme.spacing(0.75),
    },
  },
  
  taskActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  
  // ✅ ESTILOS PARA CHIPS DE PRIORIDAD
  priorityHigh: {
    backgroundColor: '#e74c3c',
    color: 'white',
    fontWeight: 'bold',
  },
  
  priorityMedium: {
    backgroundColor: '#f39c12',
    color: 'white',
    fontWeight: 'bold',
  },
  
  priorityLow: {
    backgroundColor: '#27ae60',
    color: 'white',
    fontWeight: 'bold',
  },
  
  // ✅ ESTILOS PARA CHIPS DE ESTADO
  statusPending: {
    backgroundColor: '#6c757d',
    color: 'white',
  },
  
  statusCompleted: {
    backgroundColor: '#28a745',
    color: 'white',
  },
  
  // ✅ CORREGIDO: FilterContainer dinámico según tema
  filterContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 14,
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.mode === 'dark' ? '#334155' : '#e5e8f0'}`,
    boxShadow: theme.mode === 'dark' ? '0 1px 2px rgba(0,0,0,0.4)' : '0 1px 2px rgba(20,28,48,0.06)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.25),
      marginBottom: theme.spacing(1),
    },
  },
  
  filterRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
    },
  },
  searchField: {
    minWidth: 220,
    flex: '1 1 220px',
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      width: '100%',
    },
  },
  
  // ✅ ESTILOS PARA ESTADÍSTICAS
  statsContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  
  // ✅ CORREGIDO: StatCard dinámico según tema
  statCard: {
    flex: 1,
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 14,
    border: `1px solid ${theme.mode === 'dark' ? '#334155' : '#e5e8f0'}`,
    boxShadow: theme.mode === 'dark' ? '0 1px 2px rgba(0,0,0,0.4)' : '0 1px 2px rgba(20,28,48,0.06)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  
  // ✅ CORREGIDO: StatNumber dinámico según tema
  statNumber: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  
  // ✅ CORREGIDO: StatLabel dinámico según tema
  statLabel: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary || theme.palette.text.primary,
    marginTop: theme.spacing(0.5),
  },
  
  // ✅ CORREGIDO: TasksContainer dinámico según tema
  tasksContainer: {
    flex: '0 0 auto',
    maxHeight: 'none',
    overflow: 'visible',
    paddingRight: 0,
    minHeight: theme.spacing(8),
    WebkitOverflowScrolling: 'touch',
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'none',
      overflow: 'visible',
      paddingRight: 0,
    },
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.mode === 'dark' ? '#374151' : '#f1f1f1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.mode === 'dark' ? '#6B7280' : '#c1c1c1',
      borderRadius: '4px',
      '&:hover': {
        background: theme.mode === 'dark' ? '#9CA3AF' : '#a8a8a8',
      },
    },
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  // ✅ CORREGIDO: FormControl dinámico según tema
  formControl: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      "&.Mui-focused": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiSelect-root": {
      color: theme.palette.text.primary,
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      },
    },
  },
}));

const ToDoList = () => {
  const classes = useStyles();
  const theme = useTheme();
  const storageKey = 'todolist-tasks';
  const migrationKey = 'todolist-tasks-migrated-to-api-v1';

  // ✅ ESTADOS PRINCIPALES
  const [task, setTask] = useState('');
  const [priority, setPriority] = useState('medium');
  const [category, setCategory] = useState('general');
  const [tasks, setTasks] = useState([]);
  const [editTaskId, setEditTaskId] = useState(null);
  const [tasksLoaded, setTasksLoaded] = useState(false);
  const [loadingTasks, setLoadingTasks] = useState(true);
  const [selectedTask, setSelectedTask] = useState(null);
  
  // ✅ ESTADOS PARA FILTROS
  const [searchTerm, setSearchTerm] = useState('');
  const [filterPriority, setFilterPriority] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCategory, setFilterCategory] = useState('all');

  const categories = useMemo(
    () => [
      { value: 'general', label: i18n.t('toDoList.categories.general') },
      { value: 'urgent', label: i18n.t('toDoList.categories.urgent') },
      { value: 'followup', label: i18n.t('toDoList.categories.followup') },
      { value: 'meeting', label: i18n.t('toDoList.categories.meeting') },
      { value: 'system', label: i18n.t('toDoList.categories.system') },
      { value: 'customer', label: i18n.t('toDoList.categories.customer') },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n.language],
  );

  const normalizeTask = (savedTask, index) => {
    const normalizedTask = typeof savedTask === 'string' ? { text: savedTask } : savedTask || {};
    const createdAt = normalizedTask.createdAt ? new Date(normalizedTask.createdAt) : new Date();
    const updatedAt = normalizedTask.updatedAt ? new Date(normalizedTask.updatedAt) : createdAt;

    return {
      id: normalizedTask.id || Date.now() + index,
      clientId: normalizedTask.clientId || String(normalizedTask.id || Date.now() + index),
      text: normalizedTask.text || normalizedTask.title || normalizedTask.description || '',
      priority: normalizedTask.priority || 'medium',
      category: normalizedTask.category || 'general',
      status: normalizedTask.status || 'pending',
      createdAt: Number.isNaN(createdAt.getTime()) ? new Date() : createdAt,
      updatedAt: Number.isNaN(updatedAt.getTime()) ? new Date() : updatedAt,
    };
  };

  const normalizeApiTask = (apiTask) => ({
    ...apiTask,
    createdAt: new Date(apiTask.createdAt),
    updatedAt: new Date(apiTask.updatedAt),
  });

  const getLocalTasks = () => {
    const savedTasks = localStorage.getItem(storageKey);
    if (savedTasks) {
      try {
        const parsedTasks = JSON.parse(savedTasks);
        return Array.isArray(parsedTasks)
          ? parsedTasks.map(normalizeTask).filter((savedTask) => savedTask.text.trim())
          : [];
      } catch (error) {
        console.error('Error parsing saved tasks:', error);
      }
    }
    return [];
  };

  const syncTasksFromApi = async () => {
    setLoadingTasks(true);
    const localTasks = getLocalTasks();

    try {
      const { data } = await api.get('/tasks');
      let apiTasks = Array.isArray(data?.tasks) ? data.tasks.map(normalizeApiTask) : [];

      if (localTasks.length > 0 && localStorage.getItem(migrationKey) !== 'true') {
        const importResponse = await api.post('/tasks/import', {
          tasks: localTasks.map((localTask) => ({
            ...localTask,
            clientId: String(localTask.clientId || localTask.id),
          })),
        });

        apiTasks = Array.isArray(importResponse.data?.tasks)
          ? importResponse.data.tasks.map(normalizeApiTask)
          : apiTasks;
        localStorage.setItem(migrationKey, 'true');
      }

      setTasks(apiTasks);
      localStorage.setItem(storageKey, JSON.stringify(apiTasks));
    } catch (error) {
      toastError(error);
      setTasks(localTasks);
    } finally {
      setTasksLoaded(true);
      setLoadingTasks(false);
    }
  };

  // ✅ CARGAR TAREAS DESDE API Y MIGRAR RESPALDO LOCAL SI EXISTE
  useEffect(() => {
    syncTasksFromApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ CACHE LOCAL SOLO COMO RESPALDO
  useEffect(() => {
    if (tasksLoaded) {
      localStorage.setItem(storageKey, JSON.stringify(tasks));
    }
  }, [storageKey, tasks, tasksLoaded]);

  // ✅ MANEJAR CAMBIOS EN EL FORMULARIO
  const handleTaskChange = (event) => {
    setTask(event.target.value);
  };

  const handlePriorityChange = (event) => {
    setPriority(event.target.value);
  };

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  // ✅ AGREGAR/EDITAR TAREA
  const handleAddTask = async () => {
    if (!task.trim()) {
      return;
    }

    try {
      if (editTaskId) {
        const currentTask = tasks.find((existingTask) => existingTask.id === editTaskId);
        const { data } = await api.put(`/tasks/${editTaskId}`, {
          text: task,
          priority,
          category,
          status: currentTask?.status || 'pending',
        });
        const updatedTask = normalizeApiTask(data);
        setTasks(tasks.map((existingTask) => existingTask.id === editTaskId ? updatedTask : existingTask));
      } else {
        const { data } = await api.post('/tasks', {
          text: task,
          priority,
          category,
          status: 'pending',
          clientId: String(Date.now()),
        });
        setTasks([normalizeApiTask(data), ...tasks]);
      }
      resetForm();
    } catch (error) {
      toastError(error);
    }
  };

  // ✅ RESETEAR FORMULARIO
  const resetForm = () => {
    setTask('');
    setPriority('medium');
    setCategory('general');
    setEditTaskId(null);
  };

  // ✅ EDITAR TAREA
  const handleEditTask = (taskId) => {
    const taskToEdit = tasks.find((existingTask) => existingTask.id === taskId);
    if (!taskToEdit) return;
    setTask(taskToEdit.text);
    setPriority(taskToEdit.priority);
    setCategory(taskToEdit.category);
    setEditTaskId(taskId);
  };

  // ✅ ELIMINAR TAREA
  const handleDeleteTask = async (taskId) => {
    try {
      await api.delete(`/tasks/${taskId}`);
      setTasks(tasks.filter((existingTask) => existingTask.id !== taskId));
    } catch (error) {
      toastError(error);
    }
  };

  // ✅ CAMBIAR ESTADO DE TAREA
  const handleToggleStatus = async (taskId) => {
    const taskToUpdate = tasks.find((existingTask) => existingTask.id === taskId);
    if (!taskToUpdate) return;

    try {
      const { data } = await api.put(`/tasks/${taskId}`, {
        text: taskToUpdate.text,
        priority: taskToUpdate.priority,
        category: taskToUpdate.category,
        status: taskToUpdate.status === 'pending' ? 'completed' : 'pending',
      });
      const updatedTask = normalizeApiTask(data);
      setTasks(tasks.map((existingTask) => existingTask.id === taskId ? updatedTask : existingTask));
    } catch (error) {
      toastError(error);
    }
  };

  // ✅ FILTRAR TAREAS
  const filteredTasks = tasks.filter(task => {
    const matchesSearch = task.text.toLowerCase().includes(searchTerm.trim().toLowerCase());
    const matchesPriority = filterPriority === 'all' || task.priority === filterPriority;
    const matchesStatus = filterStatus === 'all' || task.status === filterStatus;
    const matchesCategory = filterCategory === 'all' || task.category === filterCategory;
    
    return matchesSearch && matchesPriority && matchesStatus && matchesCategory;
  });

  // ✅ CALCULAR ESTADÍSTICAS
  const stats = {
    total: tasks.length,
    pending: tasks.filter(t => t.status === 'pending').length,
    completed: tasks.filter(t => t.status === 'completed').length,
    urgent: tasks.filter(t => t.priority === 'high').length,
  };

  // ✅ OBTENER ESTILO DE PRIORIDAD
  const getPriorityStyle = (priority) => {
    switch (priority) {
      case 'high': return classes.priorityHigh;
      case 'medium': return classes.priorityMedium;
      case 'low': return classes.priorityLow;
      default: return classes.priorityMedium;
    }
  };

  // ✅ OBTENER ESTILO DE ESTADO
  const getStatusStyle = (status) => {
    return status === 'completed' ? classes.statusCompleted : classes.statusPending;
  };

  // ✅ OBTENER LABEL DE PRIORIDAD
  const getPriorityLabel = (priority) => {
    switch (priority) {
      case 'high':
        return i18n.t('toDoList.priority.high');
      case 'medium':
        return i18n.t('toDoList.priority.medium');
      case 'low':
        return i18n.t('toDoList.priority.low');
      default:
        return i18n.t('toDoList.priority.medium');
    }
  };

  // ✅ OBTENER LABEL DE CATEGORÍA
  const getCategoryLabel = (category) => {
    const cat = categories.find((c) => c.value === category);
    return cat ? cat.label : i18n.t('toDoList.categories.general');
  };

  const resetFilters = () => {
    setSearchTerm('');
    setFilterPriority('all');
    setFilterStatus('all');
    setFilterCategory('all');
  };

  const handleCloseTaskDetails = () => {
    setSelectedTask(null);
  };

  const handleEditFromDialog = () => {
    if (!selectedTask) return;
    handleEditTask(selectedTask.id);
    handleCloseTaskDetails();
  };

  const formatTaskDate = (date) => {
    if (!date || Number.isNaN(new Date(date).getTime())) {
      return i18n.t('toDoList.details.notAvailable');
    }

    return new Date(date).toLocaleString();
  };

  return (
    <MainContainer>
      <div className={classes.root}>
      <MainHeader>
        <Title>
          <Box display="flex" alignItems="center">
            <NotesIcon style={{ marginRight: 8 }} />
            {i18n.t('toDoList.title')}
          </Box>
        </Title>
      </MainHeader>

      {/* ✅ ESTADÍSTICAS */}
      <div className={classes.statsContainer}>
        <div className={classes.statCard}>
          <div className={classes.statNumber}>{stats.total}</div>
          <div className={classes.statLabel}>{i18n.t('toDoList.stats.total')}</div>
        </div>
        <div className={classes.statCard}>
          <div className={classes.statNumber}>{stats.pending}</div>
          <div className={classes.statLabel}>{i18n.t('toDoList.stats.pending')}</div>
        </div>
        <div className={classes.statCard}>
          <div className={classes.statNumber}>{stats.completed}</div>
          <div className={classes.statLabel}>{i18n.t('toDoList.stats.completed')}</div>
        </div>
        <div className={classes.statCard}>
          <div className={classes.statNumber}>{stats.urgent}</div>
          <div className={classes.statLabel}>{i18n.t('toDoList.stats.urgent')}</div>
        </div>
      </div>

      {/* ✅ FORMULARIO DE NUEVA TAREA */}
      <Paper className={classes.formContainer}>
        <Typography variant="h6" gutterBottom style={{ color: theme.palette.text.primary }}>
          {editTaskId ? i18n.t('toDoList.form.editTask') : i18n.t('toDoList.form.newTask')}
        </Typography>
        
        <div className={classes.formRow}>
          <TextField
            className={`${classes.formField} ${classes.textField}`}
            label={i18n.t('toDoList.form.descriptionLabel')}
            value={task}
            onChange={handleTaskChange}
            variant="outlined"
            placeholder={i18n.t('toDoList.form.descriptionPlaceholder')}
            multiline
            rows={2}
          />
        </div>
        
        <div className={classes.formRow}>
          <FormControl className={`${classes.priorityField} ${classes.formControl}`} variant="outlined">
            <InputLabel>{i18n.t('toDoList.form.priority')}</InputLabel>
            <Select
              value={priority}
              onChange={handlePriorityChange}
              label={i18n.t('toDoList.form.priority')}
            >
              <MenuItem value="low">{i18n.t('toDoList.priority.low')}</MenuItem>
              <MenuItem value="medium">{i18n.t('toDoList.priority.medium')}</MenuItem>
              <MenuItem value="high">{i18n.t('toDoList.priority.high')}</MenuItem>
            </Select>
          </FormControl>
          
          <FormControl className={`${classes.categoryField} ${classes.formControl}`} variant="outlined">
            <InputLabel>{i18n.t('toDoList.form.category')}</InputLabel>
            <Select
              value={category}
              onChange={handleCategoryChange}
              label={i18n.t('toDoList.form.category')}
            >
              {categories.map(cat => (
                <MenuItem key={cat.value} value={cat.value}>
                  {cat.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddTask}
            startIcon={<AddIcon />}
            disabled={!task.trim()}
          >
            {editTaskId ? i18n.t('toDoList.form.save') : i18n.t('toDoList.form.add')}
          </Button>
          
          {editTaskId && (
            <Button
              variant="outlined"
              onClick={resetForm}
            >
              {i18n.t('toDoList.form.cancel')}
            </Button>
          )}
        </div>
      </Paper>

      {/* ✅ FILTROS */}
      <Paper className={classes.filterContainer}>
        <Typography variant="subtitle1" gutterBottom style={{ color: theme.palette.text.primary }}>
          <FilterListIcon style={{ marginRight: 8, verticalAlign: 'middle', color: theme.palette.text.primary }} />
          {i18n.t('toDoList.filters.title')}
        </Typography>
        <div className={classes.filterRow}>
          <TextField
            placeholder={i18n.t('toDoList.searchPlaceholder')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            variant="outlined"
            margin="dense"
            className={classes.searchField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: theme.palette.text.secondary || "gray" }} />
                </InputAdornment>
              ),
            }}
          />
          <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 150 }}>
            <InputLabel>{i18n.t('toDoList.form.priority')}</InputLabel>
            <Select
              value={filterPriority}
              onChange={(e) => setFilterPriority(e.target.value)}
              label={i18n.t('toDoList.form.priority')}
            >
              <MenuItem value="all">{i18n.t('toDoList.filters.all')}</MenuItem>
              <MenuItem value="high">{i18n.t('toDoList.priority.high')}</MenuItem>
              <MenuItem value="medium">{i18n.t('toDoList.priority.medium')}</MenuItem>
              <MenuItem value="low">{i18n.t('toDoList.priority.low')}</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 150 }}>
            <InputLabel>{i18n.t('toDoList.form.category')}</InputLabel>
            <Select
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value)}
              label={i18n.t('toDoList.form.category')}
            >
              <MenuItem value="all">{i18n.t('toDoList.filters.allCategories')}</MenuItem>
              {categories.map(cat => (
                <MenuItem key={cat.value} value={cat.value}>
                  {cat.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 150 }}>
            <InputLabel>{i18n.t('toDoList.filters.status')}</InputLabel>
            <Select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              label={i18n.t('toDoList.filters.status')}
            >
              <MenuItem value="all">{i18n.t('toDoList.filters.allStatus')}</MenuItem>
              <MenuItem value="pending">{i18n.t('toDoList.statusLabel.pending')}</MenuItem>
              <MenuItem value="completed">{i18n.t('toDoList.statusLabel.completed')}</MenuItem>
            </Select>
          </FormControl>
        </div>
      </Paper>

      {/* ✅ LISTA DE TAREAS CON SCROLL */}
      <div className={classes.tasksContainer}>
        {loadingTasks ? (
          <Paper style={{
            padding: 32,
            textAlign: 'center',
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
          }}>
            <Typography variant="h6" style={{ color: theme.palette.text.primary }}>
              {i18n.t('toDoList.loading')}
            </Typography>
          </Paper>
        ) : filteredTasks.length === 0 ? (
          <Paper style={{ 
            padding: 32, 
            textAlign: 'center', 
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
          }}>
            <Typography variant="h6" style={{ color: theme.palette.text.primary }}>
              {tasks.length === 0 ? i18n.t('toDoList.empty.none') : i18n.t('toDoList.empty.filtered')}
            </Typography>
            <Typography variant="body2" style={{ marginTop: 8, color: theme.palette.text.secondary || theme.palette.text.primary }}>
              {tasks.length === 0 ? i18n.t('toDoList.empty.noneHint') : i18n.t('toDoList.empty.filteredHint')}
            </Typography>
            {tasks.length > 0 && (
              <Button
                variant="outlined"
                color="primary"
                onClick={resetFilters}
                style={{ marginTop: 16 }}
              >
                {i18n.t('toDoList.filters.clear')}
              </Button>
            )}
          </Paper>
        ) : (
          filteredTasks.map((task) => (
            <Card
              key={task.id}
              className={`${classes.taskCard} ${task.status === 'completed' ? classes.completedTask : ''}`}
              onClick={() => setSelectedTask(task)}
            >
              <CardContent className={classes.taskContent}>
                <div className={classes.taskSummaryCard}>
                  <div className={classes.taskSummaryContent}>
                    <Typography className={classes.taskSummaryTitle} variant="subtitle1">
                      {task.text}
                    </Typography>

                    <div className={classes.taskMeta}>
                      <Chip
                        label={getPriorityLabel(task.priority)}
                        className={getPriorityStyle(task.priority)}
                        size="small"
                        icon={<PriorityHighIcon />}
                      />

                      <Chip
                        label={getCategoryLabel(task.category)}
                        variant="outlined"
                        size="small"
                      />

                      <Chip
                        label={task.status === 'completed' ? i18n.t('toDoList.statusLabel.completed') : i18n.t('toDoList.statusLabel.pending')}
                        className={getStatusStyle(task.status)}
                        size="small"
                        icon={task.status === 'completed' ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                      />

                      <Box display="flex" alignItems="center" style={{ minWidth: 0 }}>
                        <ScheduleIcon style={{ fontSize: 16, marginRight: 4, color: theme.palette.text.secondary || '#6c757d' }} />
                        <Typography variant="caption" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                          {task.updatedAt.toLocaleDateString()} {task.updatedAt.toLocaleTimeString()}
                        </Typography>
                      </Box>
                    </div>

                    <div className={classes.taskDates}>
                      <span className={classes.taskDateItem}>
                        <ScheduleIcon style={{ fontSize: 15, marginRight: 4 }} />
                        <Typography variant="caption">
                          {i18n.t('toDoList.details.createdAt')}: {formatTaskDate(task.createdAt)}
                        </Typography>
                      </span>
                      <span className={classes.taskDateItem}>
                        <ScheduleIcon style={{ fontSize: 15, marginRight: 4 }} />
                        <Typography variant="caption">
                          {i18n.t('toDoList.details.updatedAt')}: {formatTaskDate(task.updatedAt)}
                        </Typography>
                      </span>
                    </div>
                  </div>

                  <CardActions
                    className={classes.taskActions}
                    onClick={(event) => event.stopPropagation()}
                  >
                    <IconButton
                      onClick={() => handleToggleStatus(task.id)}
                      color={task.status === 'completed' ? 'default' : 'primary'}
                      title={task.status === 'completed' ? i18n.t('toDoList.tooltips.markPending') : i18n.t('toDoList.tooltips.markDone')}
                    >
                      {task.status === 'completed' ? <RadioButtonUncheckedIcon /> : <CheckCircleIcon />}
                    </IconButton>

                    <IconButton
                      onClick={() => handleEditTask(task.id)}
                      color="primary"
                      title={i18n.t('toDoList.tooltips.edit')}
                    >
                      <EditIcon />
                    </IconButton>

                    <IconButton
                      onClick={() => handleDeleteTask(task.id)}
                      color="secondary"
                      title={i18n.t('toDoList.tooltips.delete')}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </CardActions>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>

      <Dialog
        open={Boolean(selectedTask)}
        onClose={handleCloseTaskDetails}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{i18n.t('toDoList.details.title')}</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {selectedTask && (
            <>
              <Typography className={classes.detailLabel}>
                {i18n.t('toDoList.details.content')}
              </Typography>
              <Typography className={classes.detailText} variant="body1">
                {selectedTask.text}
              </Typography>

              <Box my={2}>
                <Divider />
              </Box>

              <div className={classes.detailGrid}>
                <Box>
                  <Typography className={classes.detailLabel}>
                    {i18n.t('toDoList.details.priority')}
                  </Typography>
                  <Chip
                    label={getPriorityLabel(selectedTask.priority)}
                    className={getPriorityStyle(selectedTask.priority)}
                    size="small"
                    icon={<PriorityHighIcon />}
                  />
                </Box>

                <Box>
                  <Typography className={classes.detailLabel}>
                    {i18n.t('toDoList.details.category')}
                  </Typography>
                  <Chip
                    label={getCategoryLabel(selectedTask.category)}
                    variant="outlined"
                    size="small"
                  />
                </Box>

                <Box>
                  <Typography className={classes.detailLabel}>
                    {i18n.t('toDoList.details.status')}
                  </Typography>
                  <Chip
                    label={selectedTask.status === 'completed' ? i18n.t('toDoList.statusLabel.completed') : i18n.t('toDoList.statusLabel.pending')}
                    className={getStatusStyle(selectedTask.status)}
                    size="small"
                    icon={selectedTask.status === 'completed' ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                  />
                </Box>

                <Box>
                  <Typography className={classes.detailLabel}>
                    {i18n.t('toDoList.details.id')}
                  </Typography>
                  <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                    #{selectedTask.id}
                  </Typography>
                </Box>

                <Box>
                  <Typography className={classes.detailLabel}>
                    {i18n.t('toDoList.details.createdAt')}
                  </Typography>
                  <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                    {formatTaskDate(selectedTask.createdAt)}
                  </Typography>
                </Box>

                <Box>
                  <Typography className={classes.detailLabel}>
                    {i18n.t('toDoList.details.updatedAt')}
                  </Typography>
                  <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                    {formatTaskDate(selectedTask.updatedAt)}
                  </Typography>
                </Box>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTaskDetails}>
            {i18n.t('toDoList.details.close')}
          </Button>
          <Button color="primary" variant="contained" onClick={handleEditFromDialog}>
            {i18n.t('toDoList.tooltips.edit')}
          </Button>
        </DialogActions>
      </Dialog>
      </div>
    </MainContainer>
  );
};


export default ToDoList;
